import React from 'react'
import { Checkbox, Popover, Whisper } from 'rsuite'
import { Cell } from 'rsuite-table'

type CheckCellProps = {
  rowData?: any
  dataKey: string
  readonly?: boolean | ((rowData: any) => boolean)
  checkedKeys: any[]
  popoverContent?: (rowData: any) => JSX.Element | null
  onChange: (value: any, checked: boolean) => void
}

const CheckCell: React.FC<CheckCellProps> = ({
  rowData,
  dataKey,
  readonly,
  checkedKeys,
  onChange,
  popoverContent,
  ...props
}) => {
  let isReadOnly: boolean = readonly as boolean
  if (typeof readonly === 'function' && rowData) {
    isReadOnly = readonly?.(rowData)
  }

  let speakerContent

  if (typeof popoverContent === 'function' && rowData) {
    speakerContent = popoverContent?.(rowData)
  }

  const handleChange = (value: any, checked: boolean) => {
    onChange(value, checked)
  }

  const speaker = <Popover className="cell-popover">{speakerContent}</Popover>

  return (
    <Cell {...props}>
      <div className="check-cell-wrapper">
        {speakerContent ? (
          <Whisper placement="bottom" speaker={speaker} preventOverflow>
            <Checkbox
              value={rowData[dataKey]}
              inline
              onChange={(_, checked) => handleChange(rowData[dataKey], checked)}
              readOnly={isReadOnly}
              disabled={isReadOnly}
              checked={isReadOnly || checkedKeys.includes(rowData[dataKey])}
            />
          </Whisper>
        ) : (
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={(_, checked) => handleChange(rowData[dataKey], checked)}
            readOnly={isReadOnly}
            disabled={isReadOnly}
            checked={checkedKeys.includes(rowData[dataKey])}
          />
        )}
      </div>
    </Cell>
  )
}

export default CheckCell
